import React, { useEffect, useState } from 'react';
import { PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

const FullScreenIcon: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const [fullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    const handleChange = () => {
      setFullscreen(Boolean(document.fullscreenElement));
    };
    document.addEventListener('fullscreenchange', handleChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleChange);
    };
  }, []);

  return (
    <svg
      className="PhotoView-Slider__toolbarIcon"
      fill="white"
      width="44"
      height="44"
      viewBox="0 0 768 768"
      onClick={onClick}
    >
      {fullscreen ? (
        <path d="M511.5 256.5h96v63h-159v-159h63v96zM448.5 607.5v-159h159v63h-96v96h-63zM256.5 256.5v-96h63v159h-159v-63h96zM160.5 511.5v-63h159v159h-63v-96h-96z" />
      ) : (
        <path d="M448.5 160.5h159v159h-63v-96h-96v-63zM544.5 544.5v-96h63v159h-159v-63h96zM160.5 319.5v-159h159v63h-96v96h-63zM223.5 448.5v96h96v63h-159v-159h63z" />
      )}
    </svg>
  );
};

const toggleFullScreen = () => {
  if (document.fullscreenElement) {
    document.exitFullscreen();
  } else {
    const portal = document.querySelector('.PhotoView-Portal') as HTMLElement;
    if (portal) portal.requestFullscreen();
  }
};

interface ReaderSliderProps {
  images: string[]; // já com ?v=version incluído
  initialIndex: number;
  onClose: () => void;
}

const ReaderSlider: React.FC<ReaderSliderProps> = ({ images, initialIndex, onClose }) => {
  const [index, setIndex] = useState(initialIndex);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const preload = new Image();
    preload.src = images[initialIndex];
  }, [images, initialIndex]);

  return (
    <PhotoSlider
      images={images.map((src, i) => ({ src, key: String(i) }))}
      index={index}
      visible={visible}
      onClose={() => {
        setVisible(false);
        onClose();
      }}
      onIndexChange={setIndex}
      loop
      toolbarRender={() => (
        <div>
          <FullScreenIcon onClick={toggleFullScreen} />
        </div>
      )}
    />
  );
};

export default ReaderSlider;
